"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const classnames_template_literals_1 = __importDefault(require("@netlify/classnames-template-literals"));
const useObjectiveComparative_1 = __importDefault(require("hooks/useObjectiveComparative/useObjectiveComparative"));
const SVGWithTooltip_1 = __importDefault(require("pages/objectiveAnalytics/helper/SVGWithTooltip"));
const InsightTextArea_1 = __importDefault(require("./InsightTextArea"));
const shadowStyle = {
    boxShadow: '0px 1px 2px rgba(15, 23, 42, 0.06), 0px 1px 3px rgba(15, 23, 42, 0.1)'
};
const SectionName = ({ data, isViewGraph }) => {
    const handleEditRow = (0, useObjectiveComparative_1.default)((state) => state.handleEditRow);
    const handleRemoveRow = (0, useObjectiveComparative_1.default)((state) => state.handleRemoveRow);
    const [isEdit, setIsEdit] = (0, react_1.useState)(false);
    const [textValue, setTextValue] = (0, react_1.useState)('');
    const wrapperInsightBoxCN = (0, classnames_template_literals_1.default)(`
    rounded-[4px] border-[1px] border-solid 
    group border-n-300 bg-n-300 w-[144px] cursor-pointer
    ${isViewGraph ? 'h-[209px]' : 'h-[144px]'}
  `);
    const handleOnBlur = () => {
        if (textValue) {
            handleEditRow({
                orderId: data.order,
                rowName: textValue
            });
            setTextValue('');
        }
        setIsEdit(false);
    };
    const handleOnClickEdit = () => {
        setTextValue(data.name);
        setIsEdit(true);
    };
    return (react_1.default.createElement(react_1.default.Fragment, null, isEdit ? (react_1.default.createElement(InsightTextArea_1.default, { id: data.order, textValue: textValue, handleOnChange: (e) => setTextValue(e.target.value), handleOnBlur: handleOnBlur, isViewGraph: isViewGraph })) : (react_1.default.createElement("div", { className: wrapperInsightBoxCN, style: shadowStyle, onClick: handleOnClickEdit, key: data.order },
        react_1.default.createElement(SVGWithTooltip_1.default, { iconName: "icon-clear", text: "Remove Row", customClass: "w-fit relative top-[8px] right-[8px] mb-[16px] float-right invisible group-hover:visible", action: () => handleRemoveRow(data.order) }),
        react_1.default.createElement("div", { className: `flex justify-center items-center overflow-hidden px-[16px] w-full ${isViewGraph ? 'h-[145px]' : 'h-[80px]'}` },
            react_1.default.createElement("p", { className: "w-[112px] break-words typography-h400 text-n-800 text-center" }, data.name))))));
};
exports.default = SectionName;
